module.exports = __webpack_public_path__ + "img/device_1011_3.4f63a92b.svg";